import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { sleep } from "@edp-utils/sleep.utils";
import { Observable } from "rxjs";
import { debounceTime } from "rxjs/operators";

@Component({
    selector: "edp-token-input",
    templateUrl: "./edp-token-input.component.html",
    styleUrls: ["./edp-token-input.component.scss"],
})
export class EdpTokenInputComponent {
    @Output() onSubmit: EventEmitter<string> = new EventEmitter();
    @Input() isError: boolean = false;

    public form: FormGroup;
    public resendCode: Observable<any>;
    public title: string;
    public description: string;
    public typeValidate: string;

    @ViewChild("digit1Input") digit1Input: ElementRef;
    @ViewChild("digit2Input") digit2Input: ElementRef;
    @ViewChild("digit3Input") digit3Input: ElementRef;
    @ViewChild("digit4Input") digit4Input: ElementRef;

    constructor(private readonly formBuilder: FormBuilder) {}

    public ngOnInit(): void {
        this.form = this.formBuilder.group({
            digit1: [null, Validators.required],
            digit2: [null, Validators.required],
            digit3: [null, Validators.required],
            digit4: [null, Validators.required],
        });
        this.handleCompleteForm();
    }

    private handleCompleteForm() {
        this.form.valueChanges.pipe(debounceTime(500)).subscribe(() => {
            if (this.form.valid) {
                this.submit();
            }
        });
    }

    private async setDigitFocus(key: string) {
        await sleep(200);
        switch (key) {
            case "digit1Input":
                this.digit1Input.nativeElement.focus();
                break;
            case "digit2Input":
                this.digit2Input.nativeElement.focus();
                break;
            case "digit3Input":
                this.digit3Input.nativeElement.focus();
                break;
            case "digit4Input":
                this.digit4Input.nativeElement.focus();
                break;
        }
    }

    public onKeyDown(event: KeyboardEvent, keyNextInput: "digit1Input" | "digit2Input" | "digit3Input" | "digit4Input"): void {
        const keyNumber = parseInt(event.key);
        
        if (!!Number(keyNumber)|| keyNumber === 0) {
            this.setDigitFocus(keyNextInput);
        }
    }

    public submit(): void {
        if (!!this.form.invalid) {
            return;
        }
        const { digit1, digit2, digit3, digit4 } = this.form.value;
        const token = `${digit1}${digit2}${digit3}${digit4}`;

        this.onSubmit.emit(token);
    }

    public clearInput() {
        this.form.get("digit1").setValue("");
        this.form.get("digit2").setValue("");
        this.form.get("digit3").setValue("");
        this.form.get("digit4").setValue("");
    }
}
